<template>
    <Dropdown
        v-show="showUserDropdown"
        @close-dropdown="close"
        :is-open="showUserDropdown"
    >
        <slot />
    </Dropdown>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Dropdown from './Dropdown.vue';

export default {
    components: {
        Dropdown,
    },
    computed: {
        ...mapState(['showUserDropdown']),
    },
    methods: {
        ...mapActions(['toggleUserDropdown']),
        close() {
            if (this.showUserDropdown) {
                this.toggleUserDropdown();
            }
        },
    },
};
</script>
